
import {Component, Vue} from "vue-property-decorator";
import {ProgramPaths} from "@/enum/ProgramPaths";

/** Lisans/TCKN uyarısının anahtarı (imzaKimligi.imzaUyarilari: lisans-yok ve tckn-eksik ikisi de bunu kullanır). */
const LISANS_UYARISI_ANAHTARI = "tckn-eksik";

/**
 * İmzacı kimlik/sürüm uyarıları (DEV-3899, DEV-3901): "İmzacı sürümü eski, yeniden kurun."
 * ve "Bu büronun eİcraPro lisansında TC kimlik numarası kayıtlı değil." gibi, kullanıcının
 * bir işlem yapmasını gerektiren kalıcı uyarılar store'daki `imzaUyarilari` getter'ından gelir.
 *
 * Kapatılabilir olanlar (eski kabuk) yalnız bu bileşenin ömrü boyunca gizlenir: sayfa
 * yenilenince geri gelir, kalıcı depoya yazılmaz. Kapatılamayanlar (TCKN/lisans) eİcraPro
 * sayfalarında sürekli görünür.
 *
 * Lisans/TCKN uyarısı yalnız eİcraPro rotalarında çizilir: İcraPro/OfisPro müşterisinin etkin
 * eİcraPro (product 3) lisansı olmayabilir ve o sayfalarda kapatılamayan, anlamsız bir şerit
 * görmemeli (yenileme/demo çubukları da program anahtarıyla süzülüyor). Eski kabuk uyarısı ise
 * imzacıyı kullanan her programı ilgilendirdiği için her rotada görünür. Süzgeç reaktif
 * `$route.path` üzerinden çalışır (store getter'ı rota değişince yeniden hesaplanmaz).
 *
 * Kurulum bağlantısı yok: EImzaServisIndir bileşeni henüz develop'ta (DEV-2118); birleşince
 * şeride `<e-imza-servis-indir/>` eklenebilir.
 */
@Component
export default class ImzaKimlikSeridi extends Vue {
  kapatilanlar: string[] = [];

  get eicraproRotasi(): boolean {
    return !!this.$route && String(this.$route.path || "").startsWith(ProgramPaths.eicrapro);
  }

  get uyarilar(): any[] {
    const liste: any[] = this.$store.getters.imzaUyarilari || [];
    if (this.eicraproRotasi) return liste;
    return liste.filter((uyari: any) => uyari.anahtar !== LISANS_UYARISI_ANAHTARI);
  }

  get gorunenUyarilar(): any[] {
    return this.uyarilar.filter((uyari: any) => this.kapatilanlar.indexOf(uyari.anahtar) === -1);
  }

  onInput(anahtar: string, acik: boolean) {
    if (!acik && this.kapatilanlar.indexOf(anahtar) === -1) {
      this.kapatilanlar.push(anahtar);
    }
  }
}
